import { forEach } from 'ramda';

import styles from './htmlStyles';

const toBase64 = (str) => {
    return btoa(unescape(encodeURIComponent(str)));
};

export const getHTML = () => {
    let opd = document.querySelector('.opd').cloneNode(true);
    const btn = opd.querySelector('button[type=submit]');

    forEach(input => {
        input.setAttribute('checked', 'checked');
    }, opd.querySelectorAll('.ant-radio-checked input'));

    forEach(input => {
        input.disabled = true;
    }, opd.querySelectorAll('input'));

    forEach(el => {
        el.style.display = 'none';
    }, opd.querySelectorAll('.hide-in-doc'));

    forEach(panel => {
        panel.style.display = 'block';
    }, opd.querySelectorAll('.ant-collapse-content'));

    forEach(textarea => {
        let parrentNode = textarea.parentNode;
        let textAreaDiv = document.createElement('div');
        textAreaDiv.innerHTML = textarea.innerHTML;
        textAreaDiv.classList.add('textarea');
        parrentNode.removeChild(textarea);
        parrentNode.appendChild(textAreaDiv);
    }, opd.querySelectorAll('.ant-form-item-children textarea'));

    if (btn) {
        btn.parentNode.removeChild(btn);
    }

    opd = opd.innerHTML;

    return (
        `<!DOCTYPE html><html><head><meta charset="utf-8"><style>${styles}</style></head><body><div class='opd'>${opd}</div></body></html>`
    );
}

export const getTestHTML = () => toBase64(getHTML());

export default () => toBase64(getHTML());
